import React, { useEffect, useRef } from 'react';
import cx from 'classnames';
import { TableBody as MuiTableBody, TableRow } from '@mui/material';

import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setTableBodyWidth } from 'store/table';
import { RootState } from 'store/types';

import TableCell from './TableCell';

import useStyles from '../styles';

const TableBody: React.FC = () => {
  const dispatch = useAppDispatch();
  const classes = useStyles();
  const { list, columns } = useAppSelector((state: RootState) => state.table);
  const tableBodyRef = useRef<HTMLTableSectionElement>(null);

  useEffect(() => {
    const width = tableBodyRef?.current?.scrollWidth;

    if (width) {
      dispatch(setTableBodyWidth(width));
    }
  }, []);

  return (
    <MuiTableBody className={classes.tableBody} ref={tableBodyRef}>
      {list.map((d: any) => (
        <TableRow
          key={crypto.randomUUID()}
          className={cx(classes.tableRow, classes.tableRowAligned)}
        >
          {columns.map(c => (
            <TableCell key={crypto.randomUUID()} data={d[c.key]} column={c} rowData={d} />
          ))}
        </TableRow>
      ))}
    </MuiTableBody>
  );
};

export default TableBody;
